import React from "react";
import Drawer from "components/common/Drawer";
import CheckinAddDrawer from "components/CommonDrawerFilter/CheckinAddDrawer";
import CheckinEditDrawer from "components/CommonDrawerFilter/CheckinEditDrawer";
// common drawer
const CheckInDrawer = ({
  handlecheckinsubmit,
  drawerOpen,
  toggleDrawer,
  connnectorData,
  detail,
  data,
  editdraweropen,
  visit_id,
  open,
  checkInDetailsStatus
}) => {
  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={() => toggleDrawer(false)}
    >
      {editdraweropen === "editDetails" && (
        <CheckinEditDrawer
          chekindetails={data}
          data={connnectorData}
          visit_id={visit_id}
          toggleDrawer={toggleDrawer}
          handlecheckinsubmit={handlecheckinsubmit}
          detail={detail}
        />
      )}
      {editdraweropen === "addDetails" && (
        <CheckinAddDrawer
          chekindetails={data}
          data={connnectorData}
          visit_id={visit_id}
          toggleDrawer={toggleDrawer}
          handlecheckinsubmit={handlecheckinsubmit}
          detail={detail}
          checkInDetailsStatus={checkInDetailsStatus}
        />
      )}
    </Drawer>
  );
};

export default CheckInDrawer;
